
export function FlatTree(data, children?: string) {

    let childrenName = children || "children";

    let result: any[] = []

    data.forEach(d => {
        let _d = { ...d };
        delete _d[childrenName];
        result = [...result, _d];
        if (d[childrenName]) {
            let c = FlatTree(d[childrenName], childrenName);
            result = [...result, ...c];
        }
    });
    return result;
}


export function getDivider(num: number) {
    switch (true) {
        case (num <= 1000):
            return 1;

        case (num < 1000000):
            return 1000;

        case (num <= 1000000000):
            return 1000000;

        case (num <= 1000000000000):
            return 1000000000;
            
        default:
            return 1;
    }
}